// routes/AllValidPaths.js
import { groupCockpitRoutes } from "./GroupCockpitRoutes";
import { staffRoutes } from "./StaffRoutes";
import { studentRoutes } from "./StudentRoutes";
import { schoolCockpitRoutes } from "./SchoolCockpitRoutes";
import { parentRoutes } from "./ParentRoutes";

// Public paths (no auth required)
const publicPaths = [
  "/",
  "/request-demo",
  "/why-ifillip",
  "/explore-more",
  "/privacy-policy",
  "/status",
  "/login",
  "/forgot-password",
  "/change-password/:email",
  "/admission-application-form-x/*",
  "/application-x-status/:id",
  "/application-x-withdrawal/:id",
  "/admission-application-form-xii/*",
  "/application-xii-status/:id",
  "/application-xii-withdrawal/:id",
  "/form",
  "/sample-input",
  "/sample-button",
  "/sample-timepicker",
  "/sample-monthpicker",
  "/sample-datepicker",
  "/sample-dropdown",
];

// Product Admin paths (role 1)
const productAdminPaths = [
  "/dashboard",
  "/dashboard/profile",
  "/dashboard/license",
  "/dashboard/licenseCreate",
  "/dashboard/masters/users",
  "/dashboard/masters/school",
  "/dashboard/masters/request-demo",
  "/dashboard/masters/admission",
  "/dashboard/reports/sales",
  "/dashboard/reports/users",
  "/dashboard/settings",
];

// Build /user/* paths from all role route configs
const buildUserPaths = (routes) => routes.map((r) => `/user/${r.path}`);

const allUserPaths = [
  "/user",
  ...buildUserPaths(groupCockpitRoutes),
  ...buildUserPaths(staffRoutes),
  ...buildUserPaths(studentRoutes),
  ...buildUserPaths(schoolCockpitRoutes),
  ...buildUserPaths(parentRoutes),
];

export const ALL_VALID_PATHS = [
  ...publicPaths,
  ...productAdminPaths,
  ...allUserPaths,
];

/**
 * Check whether a given pathname matches any known route in the app.
 * Handles dynamic segments like ":email" and ":staffId".
 */
export const isKnownPath = (pathname) => {
  // Normalize: remove trailing slash
  const cleanPath = pathname.replace(/\/$/, "") || "/";

  return ALL_VALID_PATHS.some((route) => {
    // Convert ":param" → regex segment
    const pattern =
      "^" +
      route
        .replace(/\/$/, "")
        .replace(/:[^/]+/g, "[^/]+")
        .replace(/\*/g, ".*") +
      "$";
    return new RegExp(pattern).test(cleanPath);
  });
};
